import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const navigate = useNavigate();

  const scrollToDemo = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToContact = () => {
    navigate('/lien-he');
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-r from-[#2a4b7c] to-[#3d5a80] text-white relative overflow-hidden">
      {/* Animated background orbs */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#06b6d4] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#2ecc71] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className={`max-w-4xl mx-auto text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Sẵn sàng biến dữ liệu skill thành lợi thế cạnh tranh?
          </h2>
          <p className="text-xl mb-8 text-blue-100">
            Hãy để chúng tôi tư vấn giải pháp phù hợp với doanh nghiệp của bạn
          </p>
          <div className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <button 
              onClick={scrollToDemo}
              className="bg-gradient-to-r from-[#2a5bd7] to-[#06b6d4] text-white px-8 py-4 rounded-lg font-semibold hover:from-[#06b6d4] hover:to-[#2ecc71] transition-all text-lg whitespace-nowrap hover:scale-105 hover:shadow-xl cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              Đặt lịch Demo
            </button>
            <button 
              onClick={goToContact}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#2a4b7c] transition-all text-lg whitespace-nowrap hover:scale-105 cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Liên hệ tư vấn
            </button>
          </div>
          <div className={`mt-8 text-blue-100 text-sm transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <i className="ri-shield-check-line mr-2"></i>
            Tư vấn miễn phí • Setup trong 2 tuần • Support 24/7
          </div>
        </div>
      </div>
    </section>
  );
}
